import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, Button, Link, Slide, Box } from '@mui/material';
import { enableAmplitudeTracking, optOutAmplitudeTracking, shouldShowBanner, logAmplitudeEvent, initializeAnonymousAmplitude } from '../services/amplitudeService';
import { useTranslation } from 'react-i18next';
import { EXTERNAL_LINKS } from '../../constants';
import { findLang } from '../models/lang';

// Transition component for the dialog
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const CookieBanner = () => {
    const [isVisible, setIsVisible] = useState(shouldShowBanner());
    const { t, i18n } = useTranslation('cookieBanner');

    const handleAccept = () => {
        enableAmplitudeTracking();
        setIsVisible(false);
    };

    const handleReject = () => {
        optOutAmplitudeTracking();
        setIsVisible(false);
    };

    const handleDismiss = () => {
        // Initialize Amplitude in anonymous mode to track the dismissal
        initializeAnonymousAmplitude();
        
        // Track the banner dismissal without making a choice
        logAmplitudeEvent('Consent: Dismissed', {
            consent_type: 'statistics',
            consent_source: 'booking_frontend',
            consent_action: 'dismissed',
            tracking_mode: 'anonymous',
        });
        setIsVisible(false);
    };

    if (!isVisible) {
        return null;
    }

    return (
        <Dialog
            open={isVisible}
            TransitionComponent={Transition}
            keepMounted
            disableEnforceFocus
            disablePortal
            onClose={handleDismiss}
            aria-describedby="cookie-consent-description"
            PaperProps={{
                sx: {
                    margin: 0, // Reset margin
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    maxWidth: '100%',
                    width: '100%',
                    borderRadius: '0',
                    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
                },
            }}
        >
            <DialogContent sx={{ pb: 1 }}>
                <DialogContentText id="cookie-consent-description" component="div">
                    <Box component="p" sx={{ mb: 1.5, fontSize: '0.9rem', lineHeight: 1.6 }}>
                        {t('text')}{' '}
                        <Link
                            href={EXTERNAL_LINKS[findLang(i18n.language).i18nCode].policy}
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="hover"
                        >
                            {t('dataPrivacy')}
                        </Link>
                        .
                    </Box>
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'flex-end', px: 3, pb: 2, pt: 0 }}>
                <Button onClick={handleReject} color="primary" variant="outlined" sx={{ mr: 1 }}>
                    {t('rejectCookies')}
                </Button>
                <Button onClick={handleAccept} variant="contained" color="secondary">
                    {t('acceptCookies')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CookieBanner;
